<script lang="ts">
  import EVENTS from "@/events/events";
  import trackEvents from "@/events";
  import "@splidejs/svelte-splide/css";
  import {
    FEED_BLOCK_NUDGE,
    FEED_BLOCK_NUDGE_CTA,
  } from "@/constants/constants";
  import PopupOverlay from "../organisms/PopupOverlay.svelte";
  import InstallNudgeContent from "./InstallNudgeContent.svelte";
  import { getInstallImage } from "@/utils/helpers/utils";

  export let isHardNudge = false,
    onPopupClose: () => void,
    showPopup = false,
    position: number,
    isItemInView: boolean;

  const nudgeType = isHardNudge ? FEED_BLOCK_NUDGE.HARD : FEED_BLOCK_NUDGE.SOFT;

  const trackDownloadClick = () => {
    trackEvents(EVENTS.PWA_STATIC_INSTALL_CLICK, {
      position,
      type: nudgeType,
      variant: "pwa_popup_variant-2",
      ctaType: FEED_BLOCK_NUDGE_CTA.DOWNLOAD,
    });
  };

  const onRemindLaterClick = () => {
    trackEvents(EVENTS.PWA_STATIC_INSTALL_CLICK, {
      position,
      type: nudgeType,
      variant: "pwa_popup_variant-2",
      ctaType: FEED_BLOCK_NUDGE_CTA.CLOSE,
    });
    onPopupClose();
  };

  $: if (isItemInView) {
    trackEvents(EVENTS.PWA_STATIC_INSTALL_VIEW, {
      position,
      type: nudgeType,
      variant: "pwa_popup_variant-2",
    });
  }
</script>

<PopupOverlay
  show={showPopup}
  onClose={onPopupClose}
  closeOnOutsideClick={!isHardNudge}
>
  <InstallNudgeContent
    {isHardNudge}
    {getInstallImage}
    {trackDownloadClick}
    trackRemindClick={onRemindLaterClick}
    {nudgeType}
    onClose={onPopupClose}
  />
</PopupOverlay>
